import { WorldCountry } from '../types';

export const belgiumExpanded: WorldCountry = {
  code: 'BE',
  name: 'Belgium',
  slug: 'belgium',
  population: 11590000,
  topCities: [
    // Existing major cities
    { name: 'Brussels', slug: 'brussels', population: 1218255 },
    { name: 'Antwerp', slug: 'antwerp', population: 529247 },
    { name: 'Ghent', slug: 'ghent', population: 262219 },
    { name: 'Charleroi', slug: 'charleroi', population: 201816 },
    { name: 'Liège', slug: 'liege', population: 197217 },
    { name: 'Bruges', slug: 'bruges', population: 118284 },
    { name: 'Namur', slug: 'namur', population: 111297 },
    { name: 'Leuven', slug: 'leuven', population: 101808 },
    { name: 'Mons', slug: 'mons', population: 95171 },
    { name: 'Aalst', slug: 'aalst', population: 85715 },
    
    // Expanded cities (90 more to reach 100)
    { name: 'Mechelen', slug: 'mechelen', population: 86921 },
    { name: 'La Louvière', slug: 'la-louviere', population: 81473 },
    { name: 'Kortrijk', slug: 'kortrijk', population: 76265 },
    { name: 'Hasselt', slug: 'hasselt', population: 77651 },
    { name: 'Sint-Niklaas', slug: 'sint-niklaas', population: 77589 },
    { name: 'Ostend', slug: 'ostend', population: 71494 },
    { name: 'Genk', slug: 'genk', population: 66990 },
    { name: 'Seraing', slug: 'seraing', population: 64627 },
    { name: 'Roeselare', slug: 'roeselare', population: 62016 },
    { name: 'Mouscron', slug: 'mouscron', population: 58442 },
    { name: 'Verviers', slug: 'verviers', population: 55750 },
    { name: 'Dendermonde', slug: 'dendermonde', population: 46583 },
    { name: 'Beringen', slug: 'beringen', population: 47694 },
    { name: 'Turnhout', slug: 'turnhout', population: 45384 },
    { name: 'Vilvoorde', slug: 'vilvoorde', population: 45057 },
    { name: 'Lokeren', slug: 'lokeren', population: 42082 },
    { name: 'Sint-Truiden', slug: 'sint-truiden', population: 41393 },
    { name: 'Brasschaat', slug: 'brasschaat', population: 38077 },
    { name: 'Ieper', slug: 'ieper', population: 35089 },
    { name: 'Lessines', slug: 'lessines', population: 18637 },
    { name: 'Waregem', slug: 'waregem', population: 38378 },
    { name: 'Geel', slug: 'geel', population: 39771 },
    { name: 'Aarschot', slug: 'aarschot', population: 29270 },
    { name: 'Tongeren', slug: 'tongeren', population: 30841 },
    { name: 'Binche', slug: 'binche', population: 33049 },
    { name: 'Wavre', slug: 'wavre', population: 35417 },
    { name: 'Halle', slug: 'halle', population: 40103 },
    { name: 'Ottignies-Louvain-la-Neuve', slug: 'ottignies-louvain-la-neuve', population: 31984 },
    { name: 'Schoten', slug: 'schoten', population: 34062 },
    { name: 'Diest', slug: 'diest', population: 23453 },
    { name: 'Jette', slug: 'jette', population: 52478 },
    { name: 'Mol', slug: 'mol', population: 37364 },
    { name: 'Andenne', slug: 'andenne', population: 27732 },
    { name: 'Mortsel', slug: 'mortsel', population: 25568 },
    { name: 'Heist-op-den-Berg', slug: 'heist-op-den-berg', population: 43122 },
    { name: 'Nivelles', slug: 'nivelles', population: 28750 },
    { name: 'Maasmechelen', slug: 'maasmechelen', population: 37140 },
    { name: 'Boom', slug: 'boom', population: 17664 },
    { name: 'Lommel', slug: 'lommel', population: 34626 },
    { name: 'Ronse', slug: 'ronse', population: 25712 },
    { name: 'Tienen', slug: 'tienen', population: 34650 },
    { name: 'Wetteren', slug: 'wetteren', population: 26607 },
    { name: 'Deinze', slug: 'deinze', population: 30584 },
    { name: 'Herentals', slug: 'herentals', population: 27615 },
    { name: 'Sint-Pieters-Leeuw', slug: 'sint-pieters-leeuw', population: 32842 },
    { name: 'Izegem', slug: 'izegem', population: 26577 },
    { name: 'Harelbeke', slug: 'harelbeke', population: 28447 },
    { name: 'Kapellen', slug: 'kapellen', population: 27457 },
    { name: 'Dilbeek', slug: 'dilbeek', population: 42413 },
    { name: 'Lier', slug: 'lier', population: 35551 },
    { name: 'Zemst', slug: 'zemst', population: 22516 },
    { name: 'Poperinge', slug: 'poperinge', population: 19847 },
    { name: 'Ninove', slug: 'ninove', population: 38306 },
    { name: 'Geraardsbergen', slug: 'geraardsbergen', population: 33001 },
    { name: 'Oudenaarde', slug: 'oudenaarde', population: 30896 },
    { name: 'Zottegem', slug: 'zottegem', population: 26083 },
    { name: 'Temse', slug: 'temse', population: 29464 },
    { name: 'Stabroek', slug: 'stabroek', population: 18680 },
    { name: 'Bornem', slug: 'bornem', population: 21329 },
    { name: 'Putte', slug: 'putte', population: 17349 },
    { name: 'Menen', slug: 'menen', population: 33254 },
    { name: 'Tielt', slug: 'tielt', population: 20230 },
    { name: 'Torhout', slug: 'torhout', population: 20259 },
    { name: 'Diksmuide', slug: 'diksmuide', population: 16845 },
    { name: 'Veurne', slug: 'veurne', population: 12081 },
    { name: 'Nieuwpoort', slug: 'nieuwpoort', population: 11742 },
    { name: 'Koksijde', slug: 'koksijde', population: 22273 },
    { name: 'De Panne', slug: 'de-panne', population: 10975 },
    { name: 'Knokke-Heist', slug: 'knokke-heist', population: 33818 },
    { name: 'Blankenberge', slug: 'blankenberge', population: 20846 },
    { name: 'Middelkerke', slug: 'middelkerke', population: 19909 },
    { name: 'Bredene', slug: 'bredene', population: 16982 },
    { name: 'De Haan', slug: 'de-haan', population: 12495 },
    { name: 'Zuienkerke', slug: 'zuienkerke', population: 2863 },
    { name: 'Jabbeke', slug: 'jabbeke', population: 14707 },
    { name: 'Oudenburg', slug: 'oudenburg', population: 9276 },
    { name: 'Gistel', slug: 'gistel', population: 12102 },
    { name: 'Ichtegem', slug: 'ichtegem', population: 13423 },
    { name: 'Koekelare', slug: 'koekelare', population: 8681 },
    { name: 'Kortemark', slug: 'kortemark', population: 12252 },
    { name: 'Houthulst', slug: 'houthulst', population: 8980 },
    { name: 'Langemark-Poelkapelle', slug: 'langemark-poelkapelle', population: 7771 },
    { name: 'Lo-Reninge', slug: 'lo-reninge', population: 3306 },
    { name: 'Zonnebeke', slug: 'zonnebeke', population: 12001 },
    { name: 'Heuvelland', slug: 'heuvelland', population: 8025 },
    { name: 'Messines', slug: 'messines', population: 1051 },
    { name: 'Wervik', slug: 'wervik', population: 18435 },
    { name: 'Comines-Warneton', slug: 'comines-warneton', population: 18393 },
    { name: 'Spiere-Helkijn', slug: 'spiere-helkijn', population: 2225 },
    { name: 'Avelgem', slug: 'avelgem', population: 9457 },
    { name: 'Zwevegem', slug: 'zwevegem', population: 24105 },
    { name: 'Deerlijk', slug: 'deerlijk', population: 11654 },
    { name: 'Anzegem', slug: 'anzegem', population: 14450 },
    { name: 'Wielsbeke', slug: 'wielsbeke', population: 9220 },
    { name: 'Oostrozebeke', slug: 'oostrozebeke', population: 7840 },
    { name: 'Moorslede', slug: 'moorslede', population: 10897 },
    { name: 'Ledegem', slug: 'ledegem', population: 9306 },
    { name: 'Meulebeke', slug: 'meulebeke', population: 11189 },
    { name: 'Staden', slug: 'staden', population: 11525 },
    { name: 'Ardooie', slug: 'ardooie', population: 9177 },
    { name: 'Ruiselede', slug: 'ruiselede', population: 4988 },
    { name: 'Wingene', slug: 'wingene', population: 13964 }
  ]
};
